export const pageAnalytics = {
	currency: 'NZD',
} as const;
